// Admin API — správa uživatelů a jejich zdrojů (vyžaduje is_admin = 'Y')
import { api } from './client'

export const adminApi = {
  // Uživatelé
  getUsers:    ()           => api.get('/admin/users'),
  createUser:  (data)       => api.post('/admin/users', data),
  updateUser:  (id, data)   => api.put(`/admin/users/${id}`, data),
  deleteUser:  (id, { notify = false } = {}) =>
    api.delete(`/admin/users/${id}${notify ? '?notify=1' : ''}`),

  // Stav účtu — approved | pending | blocked. Při 'approved' smí body nést i
  // access_source / online_source (nastaví práva jedním krokem, viz B4b).
  // Odpověď u přechodu na 'approved' účtu čekajícího na heslo obsahuje
  // { reset_link, expires_at, email_sent }.
  setUserStatus: (id, body)  => api.put(`/admin/users/${id}/status`, body),

  // Reset hesla uživatele — zneplatní staré heslo, vygeneruje odkaz.
  // Odpověď: { ok, reset_link, expires_at, email_sent, message }.
  resetUserPassword: (id, { sendEmail = true } = {}) =>
    api.post(`/admin/users/${id}/reset-password`, { sendEmail }),

  // Práva uživatele — dvě nezávislé osy (viz doc/plans/access-and-online-permissions.md):
  //   access_source: 'open' | 'oracle'          — který katalog dat smí číst
  //   online_source: 'none' | 'open' | 'oracle' — zda a odkud smí server online stahovat data
  getUserAccess: (id)       => api.get(`/admin/users/${id}/access`),
  setUserAccess: (id, data) => api.put(`/admin/users/${id}/access`, data),

  // Uložené skupiny stanic (sekce VI plánu station-group-layout.md)
  getSavedStationGroups:    ()          => api.get('/saved_station_group?sort=sort_order'),
  createSavedStationGroup:  (data)      => api.post('/admin/saved-station-groups', data),
  updateSavedStationGroup:  (id, data)  => api.put(`/admin/saved-station-groups/${id}`, data),
  deleteSavedStationGroup:  (id)        => api.delete(`/admin/saved-station-groups/${id}`),

  // Doplňkový filtr pro dvojici (skupina, produkt), viz doc/plans/group-product-filters.md
  getGroupProductFilters:   (groupId)                      => api.get(`/saved_station_group_filter?group_id=${encodeURIComponent(groupId)}`),
  saveGroupProductFilter:   (groupId, productCode, filter) => api.put(`/admin/saved-station-groups/${groupId}/filters/${encodeURIComponent(productCode)}`, { filter }),
  deleteGroupProductFilter: (groupId, productCode)         => api.delete(`/admin/saved-station-groups/${groupId}/filters/${encodeURIComponent(productCode)}`),
}
